type Locale = 'en' | 'es';

type EnsureAllLocales<L extends string> = Record<L, string>;
type TranslationTable<L extends string> = Record<string, EnsureAllLocales<L>>;

const Translations = {
    back: {
        en: 'Back',
        es: 'Atrás',
    },
    close: {
        en: 'Close',
        es: 'Cerrar',
    },
    erase_tool: {
        en: 'Erase Tool',
        es: 'Herramienta de Borrado',
    },
    finish_segment: {
        en: 'Finish Segment',
        es: 'Terminar Segmento',
    },
    flag_for_review: {
        en: 'Flag for Review',
        es: 'Marcar para Revisar',
    },
    flag_off: {
        en: 'Unflag',
        es: 'Desmarcar',
    },
    greeting: {
        en: 'Hello, {name}!', // Usage example: translate('en', 'greeting', { name: 'John' }) => 'Hello, John!'
        es: '¡Hola, {name}!',
    },
    hide_notepad: {
        en: 'Hide Notepad',
        es: 'Ocultar Bloc de Notas',
    },
    highlight_selection: {
        en: 'Highlight Selection',
        es: 'Resaltar Selección',
    },
    highlight_tool: {
        en: 'Highlight Tool',
        es: 'Herramienta de Resaltado',
    },
    notepad: {
        en: 'Notepad',
        es: 'Bloc de Notas',
    },
    notepad_placeholder: {
        en: 'Type your notes here...',
        es: 'Escribe tus notas aquí...',
    },
    segment_end: {
        en: 'Segment End',
        es: 'Fin del Segmento',
    },
    selected_language: {
        en: 'English',
        es: 'Español',
    },
    next: {
        en: 'Next',
        es: 'Próximo',
    },
    please_answer_all: {
        en: 'Please answer all questions in this segment before proceeding.',
        es: 'Por favor, responda todas las preguntas en este segmento antes de continuar.',
    },
    remove_highlight: {
        en: 'Remove Highlight',
        es: 'Eliminar Resaltado',
    },
    show_notepad: {
        en: 'Show Notepad',
        es: 'Mostrar Bloc de Notas',
    },
    review: {
        en: 'Review',
        es: 'Revisar',
    },
} as const satisfies TranslationTable<Locale>;

type TranslationKey = keyof typeof Translations;

const format = (s: string, vars?: Record<string, string | number>) =>
    s.replace(/\{(\w+)\}/g, (_, k) => String(vars?.[k] ?? ''));

export const translate = (
    locale: Locale,
    key: TranslationKey,
    vars?: Record<string, string | number>
) => format(Translations[key][locale], vars);
